define('taoQtiItem/qtiXmlRenderer/renderers/interactions/UploadInteraction',['tpl!taoQtiItem/qtiXmlRenderer/tpl/interactions/blockInteraction'], function(tpl){
    return {
        qtiClass : 'uploadInteraction',
        template : tpl
    };
});
